import React from "react";
import { Atom } from "lucide-react";
import { LogsList } from "./LogsList";

export function FrozenAgentPanel({ logs, expanded, onToggle }) {
  if (!Array.isArray(logs) || logs.length === 0) return null;
  const completedAgentsCount = logs.filter(
    (log) => log?.kind === "agent-status" && log?.meta?.state === "completed"
  ).length;

  return (
    <div style={{ margin: "0 0 0.75rem 0", padding: 0 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 10,
          padding: "6px 0",
          cursor: "pointer",
        }}
        onClick={onToggle}
        aria-expanded={expanded}
        role="button"
      >
        <Atom size={18} style={{ color: "#FFFFFF" }} />
        <span
          className="agent-analysis-label"
          style={{
            fontStyle: "Inter",
            fontWeight: 400,
            fontSize: 14,
            lineHeight: "100%",
            color: "#e5e7eb",
            display: "inline-block",
            marginRight: 6,
          }}
        >
          Agent Analysis
        </span>
        <span
          style={{ fontSize: 12, color: "#9ca3af", whiteSpace: "nowrap" }}
        >{`${completedAgentsCount} agent${completedAgentsCount === 1 ? "" : "s"} executed`}</span>
        <div
          style={{
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
            color: "#9ca3af",
            marginLeft: 8,
          }}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path
              d="M4.5 6L8 9.5L11.5 6"
              stroke="currentColor"
              strokeWidth="1.5"
              fill="none"
            />
          </svg>
        </div>
      </div>

      {expanded && (
        <div
          style={{
            maxHeight: "330px",
            padding: "0",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            overflowY: "auto",
            msOverflowStyle: "none",
            scrollbarWidth: "none",
            background: "transparent",
          }}
        >
          <LogsList logs={logs} analysisComplete={true} />
        </div>
      )}
    </div>
  );
}
